/* eslint-disable max-classes-per-file */
/* eslint-disable no-this-before-super */
/* eslint-disable no-undef */
/* eslint-disable no-plusplus */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
import "phaser";
import { SoundManager } from "./../ScenesHelpers/SoundManager";
export class Entity extends Phaser.GameObjects.Sprite {
    /** 
     * Entity constructor @param {object} scene -scene that Entity object belongs to- @param {number} x - value of Entity on x axis - @param {number} y - value of Entity on y axis - @param {String} key -contains key of Entity-
     * explode function :Destroy Entity @param {Boolean} canDestroy -destroy object or just hide it-
     * */
    constructor(scene, x, y, key, type) {
        if (key != null) {
            super(scene, x, y, key);
        } else {
            super(scene, x, y, '__MISSING_TEXTURE__');
        }
        this.scene = scene;
        if (!this.scene.textures.exists('__MISSING_TEXTURE__')) {
            this.scene.textures.addBase64('__MISSING_TEXTURE__', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO8B2qUAAAAASUVORK5CYII=');
        }
        this.scene.add.existing(this);
        this.scene.physics.world.enableBody(this, 0);
        this.setData("type", type);
        this.setData("isDead", false);
        this.sfx = SoundManager.getSfx()
    }
     explode(canDestroy) {
        if (!this.getData("isDead")) {
            this.body.setVelocity(0, 0);
            this.setAngle(0);
            this.setTexture("sprExplosion");
            this.play("sprExplosion");
            this.body.setEnable(false);
            this.sfx.explosions[
                Phaser.Math.Between(0, this.scene.sfx.explosions.length - 1)
            ].play();
            if (this.shootTimer !== undefined) {
                if (this.shootTimer) {
                    this.shootTimer.remove(false);
                }
            }
            this.on(
                "animationcomplete",
                function x() {
                    if (canDestroy) {
                        this.setData("isDead", true);
                        this.destroy();
                    } else {
                        this.setVisible(false);
                    }
                },
                this
            );
        }
    }

}